var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandmarkDome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 256H464C472.75 256 480 248.75 480 240V208C480 199.25 472.75 192 464 192H445.125C431.625 111.75 368.25 48.375 288 34.875V16C288 7.25 280.75 0 272 0H240C231.25 0 224 7.25 224 16V34.875C143.75 48.375 80.375 111.75 66.875 192H48C39.25 192 32 199.25 32 208V240C32 248.75 39.25 256 48 256ZM496 448H480V416C480 398.326 465.674 384 448 384V288H384V384H288V288H224V384H128V288H64V384C46.326 384 32 398.326 32 416V448H16C7.199 448 0 455.199 0 464V496C0 504.799 7.199 512 16 512H496C504.801 512 512 504.799 512 496V464C512 455.199 504.801 448 496 448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmarkDome);
export default __webpack_public_path__ + "static/media/landmark-dome.95a61c5753398dae5ec7ac27d9ca031f.svg";
export { ForwardRef as ReactComponent };